import Event from '@/util/proto/event'
import { isEqual , wgs2gcj , geom , speed as calcSpeed , heading as calcHeading } from '@/util/map'
import { linearSmooth5 } from '../utils/filter'
import { timestamp, datetime } from '@/util'

const extend = (src , dist) => {
  for(let i in dist) src[i] = dist
}

const filterNoise = (d) => {
  let r = linearSmooth5(d)
  d.forEach((i, index) => {
    i[0] = r[index][0]
    i[1] = r[index][1]
  })
  return d
}

const graspRoadTools = (routes , graspRoad) => {
  let graspData = routes.map((i, index, arr) => ({ x: i[0], y: i[1], ag: i[3], sp: parseInt(i[4] * 1000 / 3600), tm: index == 0 ? Math.round(timestamp(i[2]) / 1000) : Math.round(timestamp(arr[index][2]) - timestamp(arr[0][2])) }))
  let npos 
  return new Promise((resolve, reject) => {
    graspRoad.driving(graspData, (error, result) => {
      if (!error) {
        let count = result.data.points.length
        let step = (timestamp(this.routes[this.routes.length - 1][2]) - timestamp(this.routes[0][2])) / count
        let startTime = timestamp(this.routes[0][2])
        this.routes = result.data.points.map((i, index) => {
          return [i.x, i.y, datetime(startTime + index * step), 0, 100]
        })

        npos = routes.map(i => [i[0], i[1]])
      }
      resolve(npos)
    })
  })
}

const isEqualPoint = (a , b , map) => {
  let p1 = map.lngLatToContainer(new AMap.LngLat(a[0],a[1]))
  let p2 = map.lngLatToContainer(new AMap.LngLat(b[0],b[1]))
  return p1.equals(p2)
}
var geocoder
const geocoderTools = (position) => {
  if(!geocoder){
    geocoder = new AMap.Geocoder({
      radius: 500
    });
  }
  return new Promise((resolve , reject) => {
    geocoder.getAddress(position, (status, result) => {
      if (status === 'complete' && result.regeocode) {
        const g = result.regeocode.addressComponent
        let address = `${g.province}${g.city}${g.district}${g.township}${g.street}${g.streetNumber}`
        // let address = result.regeocode.formattedAddress

        resolve(address)
      }else{
        resolve('')
      }
    });
  })
}

class Track extends Event {
  constructor(map) {

    super()

    this.map = map

    this.extend({
      marker: null,
      //当前marker的dom

      markerEl: null,
      //地图朝向
      rotation: null,

      //轨迹回放当前点的游标
      pointer: 0,

      //历史轨迹数据
      routes: [],

      pitch: 0,

      //轨迹回放速度
      rate: 1,

      // 当前速度
      speed: null,

      // 轨迹回放：暂停状态
      paused: true,

      //首次实时定位
      firstLiveLocation:true,

      //滤波消除噪点
      enableFilter: false,

      // 坐标纠偏
      enableRectify: true,

      //道路锁定 500个点内
      enableGraspRoad: false,

      //3d模式下旋转角度
      defaultAngle: 0,

      //轨迹线
      trackPolyline: null,

      //轨迹线 已行驶部分
      passedPolyline: null,

      //轨迹线 已行驶部分的数据
      passedPolylineData: [],

      //逆地址编码工具
      geocoder:null,

      geocoderTimer:null,

      graspRoad: null,

      raw: []
    })

    this.createMarker();

    if (!this.graspRoad) {
      this.graspRoad = new AMap.GraspRoad()
    }

    this.startTask()

  }

  createMarker() {
    this.markerEl = document.createElement('div')
    this.markerEl.setAttribute('style','')
    this.markerEl.className = 'sl-amap-loction'

    this.marker = new AMap.Marker({
      position: this.map.getCenter(),
      content: this.markerEl,
      offset: new AMap.Pixel(-10, -10),
      autoRotation: false,
      angle: this.defaultAngle,
    });

    this.marker.on('moving', this.onMarkerMoving, this);

    this.marker.on('moveend', this.onMarkerMoveend, this);
  }

  removeMarker() {
    this.marker.setMap(null);
    this.marker.off('moving', this.onMarkerMoving, this);
    this.marker.off('moveend', this.onMarkerMoveend, this);
  }

  startTask(){
    this._startGeocoder()
  }

  onMarkerMoving(e) {
    if (this.passedPolyline) {
      let position = this.getPassedRoute().concat(e.passedPath)
      this.passedPolyline.setPath(position)
    }
  }

  // TODO 
  // 移动距离小于1像素时 不会触发，需要 从两个点的屏幕像素距离来 判断是否要进行 moveTo
  onMarkerMoveend(e) {
    if (!this.paused) this.tick()
  }

  /**
   * 播放 / 暂停
   */
  play(track) {
    let res, start = false
    if (track) {
      start = true
      res = this.load(track, true)
    }

    if (res) {
      res.then(() => {
        this.paused = false
        this.tick()
      })
    } else {
      this.paused = false
      if (start) {
        this.tick()
      } else {
        if (this.marker) {
          this.marker.resumeMove()
        }
      }

    }

  }

  /**
   * 加载历史轨迹
   * track [ [[longitude, i.latitude],recordDatetime , degree , speed] , ...]
   */
  load(track, play) {
    this.pointer = 0
    this.routes = track
    let trackPos = []
    let mileage = track.reduce((t , i) => (t + (i[5] || 0)),0)

    if (this.enableFilter) {
      filterNoise(this.routes)
    }

    if (this.enableRectify) {
      this.routes.forEach((i, index) => {
        // this.routes[index] = wgs2gcj(i[0], i[1]).concat(i[2])
        let r = wgs2gcj(i[0], i[1])
        trackPos.push([r[0], r[1]])
        this.routes[index] = [r[0], r[1], i[2], i[3], i[4]]
      })
    }

    let start = new AMap.LngLat(track[0][0], track[0][1])
    this.marker.setMap(this.map)
    this.map.setZoomAndCenter(17, start)
    this.marker.setPosition(start)

    //锁路
    if (this.enableGraspRoad) {
      this.raw = this.routes.map(i => ({ lat: i[1], lng: i[0] }))

      graspRoadTools(this.routes, graspRoad).then((pos) => {
        this._loadProcess(pos || trackPos)
      })

    } else {
      this._loadProcess(trackPos)
    }
  }

  //获取当前坐标
  getLocation(){
    let current = this.routes[this.pointer]
    return new AMap.LngLat(current[0] , current[1])
  }

  _startGeocoder(){
    if( this.marker ){
      let position = this.marker.getPosition()
      geocoderTools(position).then(resp => {
        this.geocoderTimer = setTimeout(this._startGeocoder.bind(this) , 2 * 1000)
        this.trigger('address.update' , resp)
      })
    }
    
  }

  _loadProcess(path) {

    if (this.trackPolyline) {
      this.trackPolyline.setPath(path)
    } else {
      this.trackPolyline = new AMap.Polyline({
        map: this.map,
        path: path,
        showDir: true,
        strokeColor: "#87364e",
        strokeOpacity: 0.4, //线透明度
        strokeWeight: 6, //线宽
        // strokeStyle: "solid"  //线样式,
        lineCap: 'round'
      });
    }

    if (this.passedPolyline) {
      this.passedPolyline.setPath([])
    } else {
      this.passedPolyline = new AMap.Polyline({
        map: this.map,
        showDir: true,
        strokeColor: "#087ec4",
        strokeOpacity: 0.6, //线透明度
        strokeWeight: 6, //线宽
        lineCap: 'round'
      });
    }
  }

  pause() {
    this.paused = true
    if (this.marker) {
      this.marker.pauseMove()
    }
  }

  destroy(){
    this.stop()
  }

  stop() {
    this.pointer = 0
    this.routes = []
    this.raw = []
    this.paused = true
    this.firstLiveLocation = true

    if (this.marker) {
      this.marker.stopMove()
      this.marker.setMap(null)
    }
    if (this.trackPolyline) {
      this.trackPolyline.setMap(null)
      this.trackPolyline = null
    }
    if (this.passedPolyline) {
      this.passedPolyline.setMap(null)
      this.passedPolyline = null
    }
    if(this.geocoderTimer){
      window.clearTimeout(this.geocoderTimer)
    }
  }

  seekTo(position) {
    if (this.enableGraspRoad) {
      position = Math.round(this.routes.length * position / this.raw.length)
    }
    if (position < 0 || position >= this.routes.length) return

    this.pointer = position
    let current = this.routes[this.pointer];
    let pos = new AMap.LngLat(current[0], current[1])
    this.map.setCenter(pos)
    this.marker.setPosition(pos)
    this.tick()
  }

  setRate(rate) {
    this.rate = rate
  }

  setRotation(v) {
    if(this.markerEl){
      this.markerEl.style.transform = `rotateZ(${v}deg)`
    }
  }

  setLive(position, speed, deg) {
    console.log('Live Location', position, speed, deg)
    if (this.enableRectify) {
      position = wgs2gcj(position[0], position[1])
    }

    let pos = new AMap.LngLat(position[0], position[1])

    if (deg) {
      this.setRotation(deg)
    }

    if (this.map && this.marker) {

      this.speed = speed

      if (this.firstLiveLocation) {
        this.marker.setMap(this.map)
        this.marker.setPosition(pos)
        this.firstLiveLocation = false
        setTimeout(() => {
          this.map.setCenter(pos)
        }, 100)
      } else {
        this.marker.moveTo(pos, speed || 100) // moveAlong(track, 200);
      }
    }
  }

  getNearestPoint(idx) {
    if (this.enableGraspRoad) {
      //let cur = this.routes[idx]
      //let nearest = geom.nearest({lat:cur[1] , lng:cur[0]} , this.raw)
      //return nearest
      return Math.round(this.raw.length * idx / this.routes.length)
    } else {
      return idx
    }


  }

  tick() {
    this.pointer++

    if (this.marker && this.pointer < this.routes.length && this.pointer > 0) {
      let nextPoint = this.routes[this.pointer]
      let pointer = this.getNearestPoint(this.pointer)
      this.trigger('timeupdate',[
        [nextPoint[0], nextPoint[1]], pointer, nextPoint[2], nextPoint[3], nextPoint[4]
      ])
      //current [lng, lat , time , rotation , speed]
      let lastPoint = this.routes[this.pointer - 1]

      if( !isEqualPoint(lastPoint , nextPoint , this.map)){
        let speed = calcSpeed(lastPoint , nextPoint) || nextPoint[4] || 10

        let heading = calcHeading(lastPoint , nextPoint)

        this.marker.moveTo(new AMap.LngLat(nextPoint[0], nextPoint[1]), speed * this.rate)

        this.setRotation(this.defaultAngle + heading)

        this.speed = speed

        this.map.setCenter(new AMap.LngLat(nextPoint[0], nextPoint[1]))

      } else {
        this.tick()
      }
    }

  }

  push() {

  }

  getPassedRoute() {
    return this.trackPolyline.getPath().filter((_, i) => i < this.pointer)
  }

  setView3D(flag) {
    this.pitch = flag ? 70 : 0
  }

  setMarkerStyle(className){
    this.markerEl.className = className
  }

  reset() {
    this.stop()
  }

  destory() {
    this.stop()
    if (this.marker) {
      this.removeMarker()
    }
  }
}

export default Track